import * as angular from "angular";

angular
  .module('bringoz.admin.accounts')
  .constant('Accounts_PN', {
    database: 'accounts',
    isBranchEntity: true
  });
